import React from "react";
import { useSelector } from "react-redux";

import { selectIsUserPCP } from "@/redux/selectors/authSelectors";
import { ViewContent2 } from "@/components/layout/ViewContent";

import { AptihealthTips } from "./components/AptihealthTips";
import { DraftNotesCard } from "./components/DraftNotesCard";
import { NinetyDayTreatmentWidget } from "./components/NinetyDayTreatmentWidget";
import { PatientsCard } from "./components/PatientsCard";
import { ProviderBanner } from "./components/ProviderBanner";
import { TodaysSchedule } from "./components/TodaysSchedule";
import { UpcomingCallCard } from "./components/UpcomingCallCard";
import { useDashboardData } from "./hooks/useDashboardData";
import { usePasswordResetAlert } from "./hooks/usePasswordResetAlert";
import { useProviderSchedule } from "./hooks/useProviderSchedule";
import "./styles.scss";

export function ProviderHome() {
  const isUserPCP = useSelector(selectIsUserPCP);

  const { banner, patientCount, providerDraftNotes, tips } = useDashboardData();
  const { calls, nextCall } = useProviderSchedule();

  usePasswordResetAlert();

  return (
    <ViewContent2 data-public>
      <h3 className="fs-25 mt-3 mt-lg-5 tw:font-bold">Dashboard</h3>

      {banner && (
        <ProviderBanner
          bodyText={banner.bodyText}
          clickUrl={banner.clickUrl}
          headerText={banner.headerText}
        />
      )}

      <div className="tw:grid tw:auto-cols-fr tw:gap-5 tw:lg:grid-flow-col">
        <PatientsCard isUserPCP={isUserPCP} patientCount={patientCount} />
        <UpcomingCallCard nextCall={nextCall} />

        {!isUserPCP && <DraftNotesCard numberOfDraftNotes={providerDraftNotes} />}
      </div>

      {tips && <AptihealthTips aptiTips={tips} />}

      <div className="tw:grid tw:gap-5 tw:lg:grid-flow-col tw:lg:grid-cols-[2fr_1fr]">
        <NinetyDayTreatmentWidget />
        <TodaysSchedule calls={calls} />
      </div>
    </ViewContent2>
  );
}
